"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleSelectItem = exports.MultipleSelectWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Color_enum_1 = require("../../constants/Color.enum");
exports.MultipleSelectWrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;
exports.MultipleSelectItem = styled_components_1.default.button `
    background: ${(props) => (props.isActive ? Color_enum_1.Color.Primary : Color_enum_1.Color.Background)};
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 192px;
    height: 36px;
    border-radius: 18px;
    padding: 0 18px;
    color: ${(props) => (props.isActive ? Color_enum_1.Color.Surface : Color_enum_1.Color.Primary)};
    font-size: 12px;
    font-weight: ${(props) => (props.isActive ? '500' : '300')};
`;
